import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${p => p.secondColor ? p.secondColor : '#E7EBEB'};
  height:  ${p => p.height ? `${p.height}px` : '8px'};
  border-radius: 20px;

  display: flex;
  justify-content: ${p => p.reversed ? "flex-end" : "flex-start"};
`;
